import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCcVisa,
  faCcMastercard,
  faCcApplePay,
  faGooglePay,
} from '@fortawesome/free-brands-svg-icons'
import BlikLogo from '@/assets/payment-methods/blik.svg'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import type { BillingMode } from '../types'

// Visa / Mastercard / Apple Pay / Google Pay — official FontAwesome brand icons.
// BLIK — official SVG from worldvectorlogo (CC by BLIK Polski Standard Płatności).
// P24 — inline approximation (Przelewy24 isn't in FontAwesome). Drop a real SVG
//        into client/public/payment-methods/p24.svg to swap.

const FaMark: React.FC<{ icon: typeof faCcVisa; title: string; color?: string }> = ({
  icon,
  title,
  color,
}) => (
  <span
    title={title}
    aria-label={title}
    className="tw-inline-flex tw-items-center tw-h-10"
  >
    <FontAwesomeIcon icon={icon} className="tw-text-[40px]" style={color ? { color } : undefined} />
  </span>
)

// Official BLIK mark — sourced from blik.com (logo-mobile.svg).
const BlikMark: React.FC = () => (
  <img src={BlikLogo} alt="BLIK" title="BLIK" className="tw-h-10" />
)



interface Props {
  mode: BillingMode
}

export const PaymentMethodsStrip: React.FC<Props> = ({ mode: _mode }) => {
  const { t } = useLocalize()
  // Methods offered on the Przelewy24 payment page: bank transfer, BLIK, and
  // cards (Visa / Mastercard, incl. Apple Pay / Google Pay where available).
  return (
    <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-3 tw-text-xs tw-text-content-base/70">
      <span className="tw-font-medium tw-text-content-base">{t('subscription.payments.accept')}</span>
      <div className="tw-flex tw-items-center tw-gap-2.5 tw-flex-wrap">
        <FaMark icon={faCcVisa} title="Visa" color="#1A1F71" />
        {/* cc-mastercard is a single-path glyph (can't render the multi-color
            circles); use a neutral dark so it reads as "Mastercard card" by
            shape rather than a wrong tint. */}
        <FaMark icon={faCcMastercard} title="Mastercard" color="#1A1F36" />
        <BlikMark />
        <FaMark icon={faCcApplePay} title="Apple Pay" color="#000" />
        <FaMark icon={faGooglePay} title="Google Pay" color="#5F6368" />
      </div>
      <span className="tw-text-[11px] tw-text-content-base/60 sm:tw-ml-auto">
        {t('subscription.payments.handledBy')}
      </span>
    </div>
  )
}
